// extracted by css-extract-rspack-plugin
export default {"button":"e78BK2"};